module.exports = __webpack_public_path__ + "maven.png";